module.exports = __webpack_public_path__ + "63fa53d31227ce99793b926dd2007839.svg";